import { CreateElement } from '@src/vue'

import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'

import { Element } from '@src/mixins/element/element'

import './checkbox.sass'

@Component
export class Checkbox extends Mixins<Element>(Element) {

  @Prop({ required: false })
  value: boolean

  @Prop({ required: false })
  text: string

  @Prop({ required: false })
  change: (value: boolean) => void

  @Prop({ required: false, default: 'label-right' })
  alignment: 'label-left' | 'label-right'

  // to avoid mutating a prop directly since the value will be overwritten whenever the parent component re-renders
  private actualValue: boolean = false

  mounted () {
    this.actualValue = this.value
    this.$watch('value', (value) => {
      this.actualValue = value
    })
  }

  render (h: CreateElement) {
    return (
      this.renderInput(h, this.disabled)
    )
  }

  protected renderInput (h: CreateElement, disabled: boolean) {
    return <el-checkbox class={this.alignment} v-model={this.actualValue} onChange={this.onChange} disabled={disabled}>
      {this.text}
    </el-checkbox>
  }

  protected onChange () {
    if (this.change) {
      this.change(this.actualValue)
    }
  }
}
